const config = {
  baseUrl: "https://aegisapi.edumitram.com:443",
  booking: {
    bookAppointment: "/Booking/BookAppointment",
    getBookings: "/Booking/GetBookings",
    updateBooking: "/Booking/UpdateBooking",
  },
  testimonial: {
    getAll: "/Testimonial/GetAll",
    addOrEdit: "/Testimonial/AddOrEditTestimonial",
    approve: "/Testimonial/ApproveTestimonial",
    reject: "/Testimonial/RejectTestimonial",
  },
  knowledgeCenter: {
    createEvent: "/KnowledgeCenter/CreateEvent",
    getAll: "/KnowledgeCenter/GetAll",
    delete: "/KnowledgeCenter/Delete",
  },
  auth: {
    login: "/Auth/Login",
  },
};

export const getConfig = async () => config;

export default config;
